import React from 'react';
import styled from 'styled-components';
import theme from 'shared/assets/style/theme';
import { getText, TEXT_KEY } from 'shared/utils/localization';
import { ASSET_KEY, assetSource } from 'shared/utils/assetSource';

import { styles, FormWrapper } from './../styledComponents';
import AutoFormInput from '../../../../components/AutoFormInput';
import TermsModalWrapper from '../../../../components/TermsModal/TermsModalComponents/TermsModalWrapper';
import Button from '../../../../components/Button/Button';

function DefaultForm({ handleSubmit, email, success, error, handleCancel, themeContext, handleInputChange }) {
  return (
    <TermsModalWrapper
      isVisible={true}
      closeModal={handleCancel}
      headerStyle={themeContext.ForgotPassword.ModalHeaderStyle}
      headerImageStyle={themeContext.ForgotPassword.ModalHeaderImageStyle}
      modalMainBodyStyle={themeContext.ForgotPassword.ModalMainBodyStyle}
      title={getText(TEXT_KEY.FORGOT_PASSWORD_TITLE)}
      zIndex={101}
      bodyStyle={themeContext.ForgotPassword.ModalBody}
      modalContainerStyle={themeContext.ForgotPassword.ModalContainer}
    >
      <div style={styles.modal}>
        <FormHeaderText>{getText(TEXT_KEY.ENTER_YOUR_REGISTERED_EMAIL)} </FormHeaderText>

        {!success && error && <FormErrorMessageText>{error}</FormErrorMessageText>}

        {success && <FormMessageText>{getText(TEXT_KEY.ACCOUNT_HAS_BEEN_LINKED)}</FormMessageText>}

        {!success && (
          <FormWrapper>
            <AutoFormInput
              customClassName="transparentInput"
              emitInput={e => handleInputChange(e, 'email')}
              value={email}
              label="Email"
              type="text"
              trimInput={true}
            />
            <ButtonWrapper>
              <Button
                imageSource={assetSource(ASSET_KEY.ROUNDED_RECT_PRIMARY)}
                containerStyle={Styles.formButtonImageStyle}
                imageStyle={Styles.formButtonImageStyle}
                label={getText(TEXT_KEY.SUBMIT)}
                onClick={() => handleSubmit({ email })}
              />
              <Button
                imageSource={assetSource(ASSET_KEY.ROUNDED_RECT_DANGER)}
                imageStyle={Styles.formButtonImageStyle}
                containerStyle={Styles.formButtonImageStyle}
                label={getText(TEXT_KEY.CANCEL)}
                onClick={handleCancel}
              />
            </ButtonWrapper>
          </FormWrapper>
        )}
      </div>
    </TermsModalWrapper>
  );
}

export default DefaultForm;

const FormHeaderText = styled.h6`
  text-align: center;
  font-size: 1.2vw;
  margin-top: 2rem;
  margin-bottom: 1rem;
`;

const FormMessageText = styled.p`
  text-align: center;
  color: ${theme.palette.success[1]};
`;

const FormErrorMessageText = styled(FormMessageText)`
  color: ${theme.palette.error[1]};
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 3rem;
`;

const Styles = {
  formButtonImageStyle: {
    width: '14vw',
    height: '8vh',
    maxWidth: '220px',
    maxHeight: '70px',
  },
};

